import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import muvikaAttrs from './../../attrs';
import { Button } from "@mui/material";
import TR from './../../Trans';
import { useLocalStorage } from '../../services/useLocalStorage';
import { LightMode, DarkMode } from "@mui/icons-material";

export default function ThemeToggleButton(props) {

  const [theme, setTheme] = useLocalStorage(props.isSongbook ? muvikaAttrs.service + "-songbook-theme" : muvikaAttrs.service + "-theme", "dark");
  const [isWaiting, setWaiting] = useState(false);

  useEffect(() => {
    if (!theme || theme === "dark") {
      document.documentElement.classList.remove("light-theme");
    } else {
      document.documentElement.classList.add("light-theme");
    }
  }, []);

  useEffect(() => {
    if (!theme || theme === "dark") {
      document.documentElement.classList.remove("light-theme");
    } else {
      document.documentElement.classList.add("light-theme");
    }
  }, [theme]);

  const toggleTheme = () => {
    if (theme === "light") {
      document.documentElement.classList.remove("light-theme");
      setTheme("dark");
    } else {
      document.documentElement.classList.add("light-theme");
      setTheme("light");
    }
  };

  return (
    <Button
      className="muvika-theme-button"
      disable={isWaiting}
      onClick={() => {
        toggleTheme()
        props.onClick()
      }}
      startIcon={theme === "dark" ? <LightMode /> : <DarkMode />}
      variant="text" // you can change to "contained" or "outlined" if you want
    >
      {theme === "dark" ? TR.cm_set_light_theme : TR.cm_set_dark_theme}
    </Button>
  );
}